import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

const AreYouSureModal = ({show, setShow, title, message, yesHandler, loading}) => {

    return (
        <Modal 
            show={show}
            onHide={() => setShow(false)}
        >
            {title?
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                :null
            }
            <Modal.Body>
                <p>{message}</p>
            </Modal.Body>
            <Modal.Footer className="text-end">
                {
                    loading ? 
                        <Spinner animation="border" className="text-energo" /> :
                    <>
                        <Button onClick={() => setShow(false)} variant="warning">Nein</Button>
                        <Button onClick={() => yesHandler()} className="btn-energo">Ja, ich bin sicher</Button>
                    </>
                }
            </Modal.Footer>
        </Modal>
    )
}
export default AreYouSureModal;